<template>
  <v-combobox
    v-model="materialUnitSelected"
    :items="items"
    :loading="materialUnitsLoading"
    :disabled="materialUnitsLoading"
    item-text="name"
    item-value="id"
    item-disabled="disabled"
    dense
    persistent-hint
    :label="$t('Material.units.addUnit')"
    :hint="$t('Material.units.addUnitHint')"
    :error-messages="nameErrors"
    ref="combobox"
  >
  </v-combobox>
</template>

<script>
import MaterialUnits from "@/api/material_units";
import i18n from "@/i18n";

export default {
  name: "EditorUnit",

  props: ["value", "disabledItems"],

  computed: {
    items() {
      return this.materialUnits.map((item) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem == item.name)
          : false;
        return Object.assign({}, item, { disabled });
      });
    },
  },

  data: () => ({
    serverErrors: [],
    materialUnits: [],
    materialUnitsLoading: false,
    materialUnitSelected: null,
    nameErrors: [],
  }),

  mounted() {
    this.materialUnitsLoading = true;
    MaterialUnits.fetchAllForSelect({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialUnits = response.data.units;
          }
          this.materialUnitsLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.materialUnitsLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      handler() {
        this.materialUnitSelected = this.value;
      },
    },
    materialUnitSelected: {
      handler() {
        if (!this.materialUnitSelected) {
          return; //空值不处理
        } else if (
          typeof this.materialUnitSelected == "object" &&
          this.materialUnitSelected.id
        ) {
          //现有单位
          this.$emit("input", this.materialUnitSelected);
          this.materialUnitSelected.disabled = true;
          this.$refs.combobox.blur();
        } else if (
          typeof this.materialUnitSelected == "string" &&
          this.materialUnitSelected != ""
        ) {
          //现有单位
          var existUnit = this.items.find(
            (u) => u.name == this.materialUnitSelected
          );
          if (existUnit) {
            if (existUnit.disabled) {
              this.materialUnitSelected = "";
              this.nameErrors = [i18n.t("Material.units.existUnitError")];
              this.$refs.combobox.blur();
            } else this.materialUnitSelected = existUnit;
          } else {
            //新建单位
            this.materialUnitsLoading = true;
            MaterialUnits.save(0, {
              name: this.materialUnitSelected,
            })
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    response.data.unit.disabled = true;
                    this.materialUnits.push(response.data.unit);
                    this.nameErrors = [];
                    this.$emit("input", response.data.unit);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.nameErrors = this.$resparse.getErrorMsgs(
                      response.data.error.data,
                      "name"
                    );
                  }
                  this.$refs.combobox.blur();
                  this.materialUnitsLoading = false;
                }.bind(this)
              )
              .catch(
                function () {
                  this.materialUnitsLoading = false;
                }.bind(this)
              );
          }
        }
      },
    },
  },
};
</script>
